import { Chip } from '@mui/material';

export type ActivitySummaryStatus = 'PENDING' | 'DONE';

interface ActivitySummaryChipProps {
    status: ActivitySummaryStatus;
}

const activitySummaryChipSx = (isDone: boolean) => ({
    fontSize: 12,
    height: 26,
    borderRadius: 3,
    '& .MuiChip-label': {
        px: 1.5
    },
    bgcolor: isDone ? '#E3F5E3' : '#FFFBEA',
    color: isDone ? '#2D6830' : '#BB4D02',
    fontWeight: 600
});

const ActivitySummaryChip = ({ status }: ActivitySummaryChipProps) => {
    const isDone = status === 'DONE';

    return <Chip label={isDone ? 'Realizado' : 'Pendiente'} sx={activitySummaryChipSx(isDone)} />;
};

export default ActivitySummaryChip;
